import { Skeleton } from "@mui/material";
import { useMeasurements } from "hooks/useMeasurements";
import { useTenant } from "hooks/useTenant";
import { useParams } from "react-router-dom";
import { reportStepMetadata } from "util/reportStepMetadata";

import { FacilityProductMeasurementTable } from "./FacilityProductMeasurementTable";
import { FacilityProductsTable } from "./FacilityProductsTable";
import { ProductsWithMeasurementsTable } from "./ProductsWithMeasurementsTable";
import { StepperPageHeader } from "./Report/StepperPageHeader";

export type ProductsTableProps = {
  facilityId: string;
  showReportingYearPicker?: boolean;
};

export function ProductsTable(props: ProductsTableProps) {
  const { productId } = useParams<{ productId?: string }>();
  const { hasMeasurements, loading } = useMeasurements(props.facilityId);
  const { isLKQ } = useTenant();

  if (loading) {
    return <Skeleton />;
  }
  // Specific product in measurement mode renders its own special table
  // where we don't want the Products header/description
  if (productId && hasMeasurements) {
    return <FacilityProductMeasurementTable {...props} />;
  }

  let table;
  if (hasMeasurements) {
    table = <ProductsWithMeasurementsTable {...props} />;
  } else {
    table = <FacilityProductsTable {...props} />;
  }

  // HACK: LKQ wants "Products / Equipment" instead of "Products"
  const header = isLKQ ? "Products / Equipment" : reportStepMetadata.PRODUCTS.title;

  return (
    <>
      <StepperPageHeader
        header={header}
        description={reportStepMetadata.PRODUCTS.getOverviewDescription()}
      />
      {table}
    </>
  );
}
